/**
 * @file Renders the horizontal menu that navigates between the
 * page's top-level links.
 */
import type { ReactNode } from "react";
import { Menu } from "antd";
import { useNavigate } from "react-router-dom";

import { W0 } from "@components/Constants";

export type PageMenuLink = {
  path: string;
  title: ReactNode;
};

type Props = {
  links: PageMenuLink[];
};

/**
 * Renders a horizontal menu that navigates to a link's path and
 * highlights the one matching the current URL.
 */
const PageMenu = ({ links }: Props): JSX.Element => {
  const navigate = useNavigate();

  const items = links.map(({ title: label, path: key }) => ({ label, key }));

  const { pathname } = window.location;

  const selectedKeys = links
    .map(({ path }) => path)
    .filter((path) => pathname.startsWith(path));

  /**
   * Navigates to the clicked menu item's path.
   */
  const onClick = ({ key }: { key: string }) => navigate(key);

  return (
    <Menu
      mode="horizontal"
      items={items}
      onClick={onClick}
      style={{ paddingLeft: W0, paddingTop: 3 }}
      selectedKeys={selectedKeys}
    />
  );
};

export default PageMenu;
